// extracted by mini-css-extract-plugin
export default {"FadeIn":"styles_FadeIn__40VkD","fade-in":"styles_fade-in__WA9dy"};